import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {HttpParams} from '@angular/common/http';
import {SharedApiService} from "../../shared/services/api.service";
import {AppSearch} from "../models/appSearch.model";

@Injectable()
export class AppSearchResolver implements Resolve<AppSearch> {

    constructor(
            private apiService: SharedApiService
    ) {
    }

    public resolve(route: ActivatedRouteSnapshot): Observable<AppSearch> {
        // Pass query params to http params
        let params = new HttpParams({fromObject: route.queryParams});

        return this.apiService.getAppSearch(params);
    }
}
